// extracted by mini-css-extract-plugin
module.exports = {"container":"ColorSelector_container__1jPcz","magnifier":"ColorSelector_magnifier__Lycfp"};